import { apiClient } from "./client";

export const listarInstituicoes = () => apiClient.get("/instituicoes");
export const obterInstituicao = (id) => apiClient.get(`/instituicoes/${id}`);
export const criarInstituicao = (payload) =>
  apiClient.post("/instituicoes", payload);
export const editarInstituicao = (id, payload) =>
  apiClient.put(`/instituicoes/${id}`, payload);
export const removerInstituicao = (id) =>
  apiClient.delete(`/instituicoes/${id}`);
